import { DEFAULT_TAX_LANGUAGE_KEY } from './constants';
import defaultTaxNames from './default-tax-names.json';
import taxNamesByCountry from './tax-names-by-country.json';
/**
 * @returns tax name from 3 letter country code (eg. 'usa') and language (eg. 'en'). Defaults to english ('Tax') if no matching language.
 */

export function getTaxName(countryCode, language) {
  var _countryCode$toLowerC;
  if (countryCode === void 0) {
    countryCode = '';
  }
  if (language === void 0) {
    language = '';
  }
  return ((_countryCode$toLowerC = taxNamesByCountry[countryCode.toLowerCase()]) == null ? void 0 : _countryCode$toLowerC[language.toLowerCase()]) ?? defaultTaxNames[language.toLowerCase()] ?? defaultTaxNames[DEFAULT_TAX_LANGUAGE_KEY];
}
//# sourceMappingURL=get-tax-name.js.map